import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";
import {
  BRAND,
  NAV_LINKS,
  SERVICES,
  PHONE_DISPLAY,
  PHONE_TEL,
  WHATSAPP_DISPLAY,
  WA_LINK,
} from "@/constants/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#FAF8F5]/10 bg-[#161514] pb-28 pt-16 sm:pb-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div>
            <Logo light />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#FAF8F5]/55">
              {BRAND.tagline}. Bagni, cucine e ristrutturazioni complete a{" "}
              {BRAND.city}.
            </p>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#B88E4C]">Esplora</p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.testid}`}
                    className="text-sm text-[#FAF8F5]/65 transition-colors hover:text-[#FAF8F5]"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#B88E4C]">Servizi</p>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to="/servizi"
                    data-testid={`footer-service-${s.id}-link`}
                    className="text-sm text-[#FAF8F5]/65 transition-colors hover:text-[#FAF8F5]"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#B88E4C]">Contatti</p>
            <ul className="mt-5 space-y-3 text-sm text-[#FAF8F5]/65">
              <li>
                <a
                  data-testid="footer-call-link"
                  href={PHONE_TEL}
                  className="flex items-center gap-2.5 transition-colors hover:text-[#FAF8F5]"
                >
                  <Phone size={15} className="text-[#C85A32]" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-whatsapp-link"
                  href={WA_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2.5 transition-colors hover:text-[#FAF8F5]"
                >
                  <MessageCircle size={15} className="text-[#C85A32]" /> {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <MapPin size={15} className="text-[#C85A32]" /> {BRAND.address}
              </li>
              <li className="flex items-center gap-2.5">
                <Clock size={15} className="text-[#C85A32]" /> {BRAND.hours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-[#FAF8F5]/10 pt-7 text-xs text-[#FAF8F5]/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {BRAND.name} — P.IVA 01234567890</p>
          <p className="font-mono uppercase tracking-[0.2em]">Osimo · Ancona · Marche</p>
        </div>
      </div>
    </footer>
  );
}
